import React from 'react'

export type AwardIconProps = {
  size?: number
}

export const AwardIcon = ({ size = 16 }: AwardIconProps) => (
  <svg
    fill='none'
    height={size}
    viewBox='0 0 18 18'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.1575 10.4175L5.25 17.25L9 15L12.75 17.25L11.8425 10.41M14.25 6C14.25 8.8995 11.8995 11.25 9 11.25C6.10051 11.25 3.75 8.8995 3.75 6C3.75 3.10051 6.10051 0.75 9 0.75C11.8995 0.75 14.25 3.10051 14.25 6Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)
